module.exports = __webpack_public_path__ + "static/media/64.c99d9a2b.jpg";